<app-signing-order-editor
  #signingOrder
  [itemsFormArray]="form"
  labelKey="name"
  [sortable]="templateType !== templateTypes.Document"
>
  <ng-template signerForm let-roleForm="form" let-isFlat="isFlat" let-index="index" let-draggable="draggable">
    <app-signer-item-form
      [class.flat]="isFlat"
      [form]="roleForm"
      [draggable]="draggable"
      [removable]="form.length >= 2"
      [setFormDataFunc]="onSignerSelect"
      (remove)="onRemoveSigner(index)"
      [isGuestEnabled]="true"
      [isUserEnabled]="true"
    >
    </app-signer-item-form>
  </ng-template>
</app-signing-order-editor>

<div class="d-flex gap-3 mt-3">
  <a href="javascript:;" (click)="onAddSigner()" class="btn btn-secondary-info" *ngIf="form.length < rolesLimit">
    <i class="far fa-plus"></i> <ng-container i18n>Add Signer</ng-container>
  </a>
  <a
    href="javascript:;"
    i18n-matTooltip
    matTooltip="Add yourself as a signer of this document."
    (click)="onAddMe()"
    class="btn btn-secondary-info"
    *ngIf="form.length < rolesLimit && !(isMeAsSigner$ | async)"
  >
    <i class="far fa-plus"></i> <ng-container i18n>Add Me as Signer</ng-container>
  </a>
</div>
